function helperNewDate () {
  return new Date()
}

module.exports = helperNewDate
